import { AALocationModel } from './route-model';
import { RouteLeg } from './route-signposts-model';

export class PrintModel {
  public ShowPrintModel: boolean;
  public MapSettings: any = { type: 'map-large', preparing: false };
  public HideSignPosts = false;

  constructor() { }

  resetSignPostFlag() {
    this.HideSignPosts = false;
    this.MapSettings.type = 'map-large';
  }

  reset(): void  {
    this.ShowPrintModel = false;
  }
}

export class PrintData {
  From: AALocationModel;
  To: AALocationModel;
  ShowDirection: boolean;
  Direction: RouteLeg;
}
